export class UiService {
    id: string;
    tags?: string;
    authorizations?: string[];
    label: string;
    avatar?: string;
    icon?: string;
    secondIcon?: string;
    cssClass ? = '';
    private _root?: boolean;
    private _show?: boolean;
    display?: {
        labelMoving?: boolean;
        containerType?: string
    };
    onClick?: (p: any) => any;
    url?: string;

    constructor(data) {
        for (const k of Object.keys(data)) {
            this[k] = data[k];
        }
        if (this.display === undefined) {
            this.display = {
                labelMoving: false,
                containerType: 'circle'
            };
        }
    }
    get root() {
        return this._root === undefined ? true : !!this._root;
    }
    set root(val: boolean) {
        this._root = val;
    }
    get show() {
        return this._show === undefined ? true : !!this._show;
    }
    set show(val: boolean) {
        this._show = val;
    }
}
